import { useEffect } from "react";
import { initNativeAd, initTsMasterSpot, resetAdn } from "./failovers";
import { useLocation } from "react-router-dom";
import { metrics } from "utils/metrics";
import { isDisableAds } from "./utils";
import { apiMain } from "services";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    goCtrl: any;
  }
}

const TIMEOUT = 500;

const loadScript = ({ cb } : { cb: () => void}) => {
  try {
    if (
      typeof window.goCtrl == "undefined" &&
      window.location.pathname.indexOf("/ifr/") !== 0
    ) {
      const js = document.createElement("script");

      js.async = true;
      js.onload = cb;

      js.onerror = e => {
        metrics.sendAdLoaded(false);
        console.debug("[ads] eaCtrl not found -- ads blocked?", e);
      };

      js.src = "/assets/js/goCtrl.js";

      document.head.appendChild(js);
    }
  } catch (e) {
    metrics.sendAdLoaded(false);
    console.debug("[ads] eaCtrl not found -- ads blocked?", e);
  }
};

const init = () => {
  initTsMasterSpot();
  initNativeAd();

  loadScript({
    cb: () => {
      console.debug("[ads] initializing goCtrl");

      try {
        window.goCtrl.ctrlId = 112; // the id of this controller
        window.goCtrl.debugOn = true; // set on true in case you want to debug, eaCtrl will log errors or other info in the console
        window.goCtrl.bypassAb = false; // change to enable/disable
        window.goCtrl.lazyLoading = false; // change to enable/disable lazyLoading, default it only display an ad when it reach the fold
        window.goCtrl.connectors = {
          t1: { isproxy: 0, type: "url", url: "//go.goasrv.com/eactrl.go" }
        };

        window.goCtrl.init();
        metrics.sendAdLoaded(true);
      } catch (e) {
        metrics.sendAdLoaded(false);
        console.error(`[ads] error initializing goCtrl: ${e}`);
      }
    }
  });
};

const GoCtrl = () => {
  const location = useLocation();

  useEffect(resetAdn, [location]);

  useEffect(() => {
    (async () => {
      if (isDisableAds()) {
        return;
      }

      const apiExperiments = await apiMain.getExperiments();

      if (apiExperiments?.noAds) {
        return;
      }

      setTimeout(init, TIMEOUT);
    })();
  }, []);

  return null;
};

export default GoCtrl;
